import {GetContent} from './get-content';

const initGetContent = () => {
  const getContent = new GetContent();
  getContent.init();
}

export {initGetContent};
